import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Upload, Trash2, FileText } from "lucide-react";
import { api } from "@/lib/api";

export function LeaveDocs({ leaveId, onChanged }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const inp = useRef(null);
  const load = () => api.get(`/annual-leave/${leaveId}/documents`).then((r) => setRows(r.data.rows || [])).catch(() => setRows([]));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [leaveId]);

  const upload = async (files) => {
    if (!files?.length) return;
    setBusy(true);
    let ok = 0;
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      try { await api.post(`/annual-leave/${leaveId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }); ok += 1; }
      catch (e) { toast.error(`${f.name}: ${e?.response?.data?.detail || "yüklenemedi"}`); }
    }
    if (ok) toast.success(`${ok} belge eklendi`);
    setBusy(false);
    if (inp.current) inp.current.value = "";
    load();
    if (ok) onChanged?.();
  };

  const open = async (d) => {
    try {
      const r = await api.get(`/annual-leave/documents/${d.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: d.content_type }));
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { toast.error("Belge açılamadı"); }
  };

  const remove = async (d) => {
    if (!window.confirm(`"${d.original_filename}" silinsin mi?`)) return;
    try { await api.delete(`/annual-leave/documents/${d.id}`); toast.success("Belge silindi"); load(); onChanged?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Silinemedi"); }
  };

  return (
    <div data-testid="leave-docs">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 flex items-center gap-1"><Paperclip size={11} /> Belgeler ({rows.length})</span>
        <button type="button" disabled={busy} onClick={() => inp.current?.click()} data-testid="leave-docs-upload"
          className="inline-flex items-center gap-1 text-[11px] font-semibold text-teal-700 border border-teal-300 bg-teal-50 hover:bg-teal-100 rounded px-2 py-0.5 disabled:opacity-50">
          <Upload size={11} /> {busy ? "Yükleniyor..." : "Belge ekle"}
        </button>
        <input ref={inp} type="file" multiple accept=".pdf,.jpg,.jpeg,.png" className="hidden" data-testid="leave-docs-input"
          onChange={(e) => upload([...e.target.files])} />
      </div>
      {rows.length === 0 && <div className="text-[11px] italic text-slate-400">Belge yok · PDF, JPG veya PNG (en fazla 10 MB)</div>}
      <ul className="space-y-1">
        {rows.map((d) => (
          <li key={d.id} className="flex items-center gap-2 text-xs bg-slate-50 border border-slate-200 rounded px-2 py-1" data-testid={`leave-doc-${d.id}`}>
            <FileText size={12} className="text-slate-500 shrink-0" />
            <button type="button" onClick={() => open(d)} data-testid={`leave-doc-open-${d.id}`} className="flex-1 truncate text-left text-indigo-700 hover:underline">{d.original_filename}</button>
            <button type="button" onClick={() => remove(d)} data-testid={`leave-doc-delete-${d.id}`} title="Belgeyi sil" className="w-5 h-5 grid place-items-center text-rose-600 hover:bg-rose-50 rounded"><Trash2 size={11} /></button>
          </li>
        ))}
      </ul>
    </div>
  );
}
